import { useMemo } from 'react';
import type { Layout } from 'types/layout';
import { validateString } from 'utils/validate-string';

interface Props {
  layout: Layout;
  styles: Record<string, string | undefined>;
}

export default function useLayout({ layout, styles }: Props): string {
  const layoutClass: string = useMemo(() => {
    if (layout === 'center') {
      return validateString(styles.center);
    } else if (layout === 'left') {
      return validateString(styles.left);
    } else if (layout === 'right') {
      return validateString(styles.right);
    }
    return 'left';
  }, [layout, styles]);

  return layoutClass;
}
